import { SupportedTokenName } from "@mezo/sdk"
import { Block, useStyletron } from "@mezo-org/mezo-clay"

import { getTokenIcon } from "#/shared/utils"

export default function TokenIcon({
  token,
  size,
}: {
  token: SupportedTokenName
  size?: string
}) {
  const [css, theme] = useStyletron()
  const displayTokenIcon = getTokenIcon(token)
  const iconSize = size ?? theme.sizing.scale800

  return (
    <Block
      as="img"
      src={displayTokenIcon}
      className={css({
        height: iconSize,
        width: iconSize,
        objectFit: "contain",
      })}
    />
  )
}
